'use client'

import { useCallback } from 'react'

import { saveUserConsentString } from '@marketplace-web/ads/ads-data'
import { serverSide } from '@marketplace-web/environment/environment-util'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

const useSaveUserConsentString = () => {
  const isConsentTrackingEnabled = useFeatureSwitch('web_consent_tracking_enabled')

  const saveConsentString = useCallback(() => {
    // eslint-disable-next-line no-underscore-dangle
    if (!isConsentTrackingEnabled || serverSide || typeof window.__tcfapi !== 'function') {
      return
    }

    // eslint-disable-next-line no-underscore-dangle
    window.__tcfapi('getTCData', 2, (tcData, success) => {
      if (success && tcData?.tcString) {
        saveUserConsentString({ consentString: tcData.tcString })
      }
    })
  }, [isConsentTrackingEnabled])

  return { saveConsentString }
}

export default useSaveUserConsentString
